import styled from 'styled-components'
import { NoSelect } from 'components/NoSelect'

const Role = styled(NoSelect)`${ props => `
  font-size: ${props.theme.rem()};
`}`

export {
  Role
}